<template>
  <div>
    <v-item-group v-model="optionSelected" mandatory>
      <v-item
        v-for="item in items"
        v-slot="{ active, toggle }"
        :key="item.value"
        class="my-2"
        :value="item.value"
      >
        <CardItemsComponents
          :active="active"
          :is-ready="!$store.getters.isLoading"
          @click="item.value === 0 ? (dialog = true) : (showAuthModal = true)"
          @click.capture="toggle"
        >
          <template v-slot:icon>
            <v-icon :color="active ? 'primary' : ''" v-text="item.icon" />
          </template>
          <template v-slot:body>
            <v-col cols="12">
              <span class="title-card-item-component" v-text="$t(item.name)" />
            </v-col>
            <v-col cols="12" class="pt-1">
              <span
                class="subtitle-card-item-component"
                v-text="
                  optionSelected === 0
                    ? guestInfo
                    : optionSelected === 1
                    ? userInfo
                    : ''
                "
              />
              <!--              <span-->
              <!--                v-if="item.value === 1 && optionSelected == 1"-->
              <!--                class="subtitle-card-item-component"-->
              <!--                :class="$store.getters.user ? '' : 'error'"-->
              <!--                v-text="userInfo"-->
              <!--              />-->
            </v-col>
          </template>

          <template v-slot:actions>
            <v-icon
              v-if="item.value == 0"
              :color="optionSelected === 0 && showError ? 'error' : ''"
              v-text="
                optionSelected === 0 && showError
                  ? 'mdi-alert-circle'
                  : 'mdi-arrow-right'
              "
            />
            <v-icon
              v-else
              :color="optionSelected == 1 && showError ? 'error' : ''"
              v-text="
                optionSelected == 1 && showError
                  ? 'mdi-alert-circle'
                  : 'mdi-arrow-right'
              "
            />
          </template>
        </CardItemsComponents>
      </v-item>
    </v-item-group>

    <ModalGuestInfo
      v-if="dialog"
      v-model="dialog"
      :dialog="dialog"
      @handlerLogin="handlerLogin"
    />
    <v-dialog
      v-model="showAuthModal"
      persistent
      :fullscreen="$vuetify.breakpoint.mobile"
      max-width="550"
      transition="dialog-bottom-transition"
      :content-class="$vuetify.breakpoint.mobile ? '' : 'dialog-rounded'"
      :scrollable="false"
    >
      <ModalAuthForm
        v-if="showAuthModal"
        v-model="showAuthModal"
        @cleanPaymentInfo="handlerCleanPaymentData()"
      />
    </v-dialog>
  </div>
</template>

<script>
/* VALIDATIONS:
just info
*/
import { ModalGuestInfo } from "./subcomponent";
export default {
  name: "CustomerInfo",
  components: {
    ModalGuestInfo,
  },
  data: () => ({
    dialog: false,
    showAuthModal: false,
    items: [
      {
        id: 1,
        name: "checkout.guest",
        value: 0,
        icon: "mdi-account-question-outline",
      },
      // {
      //   id: 2,
      //   name: "general.login",
      //   value: 1,
      //   icon: "mdi-login",
      // },
    ],
  }),
  computed: {
    guestInfo: {
      get() {
        if (this.$store.getters.guestInfo) {
          return (
            this.$store.getters.guestInfo.firstName +
            " " +
            this.$store.getters.guestInfo.lastName
          );
        }
        return this.$store.getters.checkoutValidation.userInfo.message;
      },
      set(val) {
        return val;
      },
    },
    userInfo: {
      get() {
        if (this.$store.getters.user) {
          return;
        }
        return this.$store.getters.checkoutValidation.userInfo.message;
      },
      set(val) {
        return val;
      },
    },
    showError: function () {
      return !this.$store.getters.checkoutValidation.userInfo.status;
    },
    optionSelected: {
      get() {
        return this.$store.getters.customerOption;
      },
      set(val) {
        this.$store.dispatch("customer/setOption", val);
        return val;
      },
    },
  },
  watch: {
    "$store.getters.guestInfo": function () {
      this.$checkoutValidator.customerInfo();
    },
    "$store.getters.customerOption": function () {
      this.$checkoutValidator.customerInfo();
    },
    "$i18n.locale": function () {
      // Re-run validation when language changes to update messages
      this.$checkoutValidator.customerInfo();
    },
  },
  mounted() {
    this.$checkoutValidator.customerInfo();
  },
  methods: {
    handlerLogin: function () {
      this.dialog = false;
      this.showAuthModal = true;
    },
    handlerCleanPaymentData: function () {
      this.$emit("cleanPaymentInfo");
    },
  },
};
</script>
